import React from "react";
import { ActionPointData } from "../../../amorg-common";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Icon } from "../../../designSystem/icons/Icons";
import { MessageCard } from "../../../designSystem/Message";
import { colors } from "../../../designSystem/colors/color";

export type ActionPlanStatus = 'no-topics' | 'no-actionpoints' | 'deadline-passed' | 'done' | 'in-progress';

export function ActionPlanStatusCard ({ status, actionPoints }: { status: ActionPlanStatus, actionPoints: ActionPointData[]; }): JSX.Element
{
    return (
        <>
            {status === 'deadline-passed' &&
                <MessageCard variant='warning'>
                    <Flex gap={8} style={{ flexGrow: 1 }} justifyContent='center' alignItems='center'>
                        <Icon name='warning' color={colors.icon.warning} />
                        <span>Deadline er overskredet for {actionPoints.filter(ap => !ap.done && ap.deadline && ap.deadline < new Date()).length} handlepunkt(er)</span>
                    </Flex>
                </MessageCard>
            }

            {status === 'done' &&
                <MessageCard variant='success'>
                    <Flex gap={8} style={{ flexGrow: 1 }} justifyContent='center' alignItems='center'>
                        <Icon name='status_ok' color={colors.icon.success} />
                        <span>All handlepunkter er gennemført</span>
                    </Flex>
                </MessageCard>
            }

            {status === 'no-actionpoints' &&
                <MessageCard variant='info'>
                    Der er endnu ikke oprettet handlepunkter
                </MessageCard>
            }

            {status === 'no-topics' &&
                <MessageCard variant='info'>
                    Der er endnu ikke oprettet emner for handleplanen
                </MessageCard>
            }
        </>
    );
}